import { logger } from '@zep/core-logger';

type Section = 'selected-map' | 'new-map-banner' | 'featured-list';

/**
 * Zepeto 이미지 로드를 감지하고 logger로 보고하는 모니터링 유틸
 * @description Zepeto 마이그레이션 이후 이미지 로드를 디버깅하기 위한 임시 코드
 * @deprecated 마이그레이션 완료 후 삭제 예정
 */
export const createZepetoImageMonitor = (section: Section) => ({
  onLoad: (e: React.SyntheticEvent<HTMLImageElement>) => {
    const url = e.currentTarget.src;

    if (!url.includes('zepeto')) return;

    console.error('[ZEPETO IMAGE LOADED]', {
      url,
      section,
    });

    // PRD 환경에서만 전송 (Sentry warning 이벤트로 전파 + HyperDX debug 로그 유지)
    if (process.env.NEXT_PUBLIC_STAGE !== 'PRD') return;

    logger.debug('zepeto_image_loaded', {
      zepetoUrl: url,
      section,
    });

    logger.captureError(new Error('zepeto_image_loaded'), {
      fingerprint: 'zepeto-image',
      level: 'warning',
      tags: { section },
      extra: { zepetoUrl: url },
    });
  },
});
